import React, { Component } from 'react';

class IconSidebarItemOfficer extends Component {
    render() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="21"
                height="21"
                fill="none"
                viewBox="0 0 21 21"
            >
                <path
                    fill={this.props.isActive ? "#26A" : "#424242"}
                    d="M18.511 17.43v-.577-2.135c0-.374-.028-.678-.076-.95-.384-2.135-1.533-3.572-3.402-4.3a5.2 5.2 0 001.36-2.914c.183-1.437-.2-2.884-1.063-3.987C13.654.473 10.636.16 8.585 1.88c-1.044.87-1.647 2.004-1.8 3.36-.192 1.659.277 3.085 1.379 4.259l-.345.111c-.067.02-.096.02-.105.02H2.482c-.479 0-.929.203-1.236.547a1.62 1.62 0 00-.392 1.194c.038.536.086 1.062.134 1.598l.393 4.462c-.786.101-1.409.87-1.38 1.72.029.92.757 1.619 1.696 1.619H18.3c.163 0 .326-.02.48-.051.747-.182 1.283-.961 1.216-1.78-.076-.83-.7-1.458-1.485-1.508zm-1.782-3.268c.029.162.038.334.038.506V17.4h-.469l.096-.537c.067-.394-.058-.647-.163-.789a.896.896 0 00-.709-.334h-1.945l-.364-4.087-.02-.324c-.009-.111-.018-.243-.047-.384 2.127.04 3.325 1.578 3.583 3.217zM9.39 3.569a2.963 2.963 0 012.175-.95c.834 0 1.62.343 2.204.95.584.617.91 1.427.9 2.297 0 .88-.325 1.71-.92 2.327a3.023 3.023 0 01-2.184.95h-.01c-1.686 0-3.065-1.456-3.075-3.247 0-.88.316-1.7.91-2.327zm2.05 7.902l.144 1.578.374 4.37H3.143c-.01-.02-.01-.06-.019-.12l-.268-3.238-.23-2.59h8.815zm6.238 8.023H2.28c-.153-.02-.258-.172-.249-.334.01-.162.106-.263.268-.283.058-.01.125 0 .182 0h15.186a.29.29 0 01.288.303.298.298 0 01-.278.314z"
                ></path>
                <path
                    fill={this.props.isActive ? "#26A" : "#424242"}
                    d="M6.807 15.782c.403 0 .782-.17 1.058-.474.288-.303.449-.716.437-1.141 0-.425-.16-.825-.448-1.117a1.544 1.544 0 00-1.07-.461c-.816.012-1.483.716-1.483 1.59 0 .413.16.826.448 1.13.276.303.667.473 1.058.473z"
                ></path>
            </svg>
        );
    }
}

export default IconSidebarItemOfficer;